import styled, { css } from "styled-components";
import { AppBar } from "@mui/material";
import { colors } from "../../../theme/globalStyles";

interface IStyledProps {
    drawerwidth: number;
    expanded: boolean | number;
    position?: string;
}

export const Container = styled(AppBar)`
  z-index: 1201 !important;
  transition: width 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
  margin 195ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;
  box-shadow: 0px 0px 0px 0px !important;
  background: ${colors.grey} !important;

  ${({ expanded }: IStyledProps) =>
      !expanded
          ? css`
      transition: width 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms,
        margin 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms !important;
      margin-left: ${({ drawerwidth }: { drawerwidth: number }) => `${drawerwidth}px`} !important;
      width: ${({ drawerwidth }: { drawerwidth: number }) => `calc(100% - ${drawerwidth}px)`} !important;
    `
          : css`
      width: ${({ drawerwidth }: { drawerwidth: number }) => `calc(100% - 55px)`} !important;
`};
`;

export const Breadcrumbs = styled.li`
  margin-left: 40px;
  color: #5B5B5F;
  font-size: 14px;
  font-family: "Roboto","Helvetica","Arial",sans-serif;
  font-weight: 500;
  list-style: none; /* Remove list bullets */
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;

  &::before {
    content: "•";
    padding-right: 8px;
    color: #E16E32; 
    font-size: 30px
  }
`;
